import { render } from "./TheImage.vue?vue&type=template&id=6a524e40&scoped=true&ts=true&lang=html"
import script from "./TheImage.vue?vue&type=script&lang=ts"
export * from "./TheImage.vue?vue&type=script&lang=ts"

import "./TheImage.vue?vue&type=style&index=0&id=6a524e40&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a524e40"]])

export default __exports__